<script lang="ts">
  import { Icon, WithList } from '$shared/components';

  interface Props {
    list?: CommonList[];
    active: string;
    onselect?: (menu: CommonList) => void;
  }

  let { list = [], active, onselect }: Props = $props();

  let showOption = $state(false);
  let hover = $state(false);

  let label = $derived(list?.find((item) => item.id === active)?.label || '');
  let iconName = $derived(showOption
    ? 'icon-chevron-up active'
    : `icon-chevron-down ${hover ? 'active' : ''}`);

  const onClickLabel = () => {
    showOption = !showOption;
  };

  const onClickOption = (menu: CommonList): void => {
    onselect?.(menu);
    showOption = false;
  };

  const onProfileMenuClose = (): void => {
    showOption = false;
  };
</script>

<div class="comp-list-option">
  <WithList
    alignRight
    {list}
    show={showOption}
    onclick={onClickOption}
    onclose={onProfileMenuClose}
    onopen={() => (showOption = true)}
  >
    <button
      type="button"
      class="label-action"
      class:active={showOption}
      onmouseenter={() => (hover = true)}
      onmouseleave={() => (hover = false)}
      onclick={onClickLabel}
    >
      <div class="label" title={label}>{label}</div>
      <div class="icon">
        <Icon value={iconName} />
      </div>
    </button>
  </WithList>
</div>

<style>
  .comp-list-option {
    position: relative;
  }
  .label-action {
    padding: 0 8px;
  }
  .label-action,
  .label-action .icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .label-action .label {
    margin-right: 8px;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 110px;
    font-weight: 500;
  }
  .label-action.active,
  .label-action:hover {
    background-color: var(--light-blue);
    color: var(--blue);
    border-color: var(--light-blue);
    border-radius: 5px;
  }
</style>
